import { defineMessages } from 'react-intl';

const messages = defineMessages({
  loginTitle: '网易游戏市场推广协同管理平台',
  accountPlaceholder: '请输入登录账号',
  pwdPlaceholder: '请输入密码',
  noNeedLoginMsg: '十天内免登录',
  forgetPwd: '忘记密码',
  loginBtnMsg: '登录',
  helpDocument: '帮助文档',
  contactUsMsg: '联系我们',
  accountAlertMsg: '请输入账号',
  captchaAlertMsg: '请先进行滑动验证',
  errorAlertMsg: '账号或密码错误',
  lockAlertMsg: '账号已锁定，请联系管理人员',
  emailPlaceholder: '请输入账号关联的邮箱',
  nextStep: '下一步',
  resetPwd: '修改密码',
  login: '账号',
  name: '用户名',
  old_password: '旧密码',
  password: '新密码',
  password_confirmation: '确认新密码',
  resetPassword: '重置密码',
  inputNewPwd: '请输入新密码',
  diffPwd: '两次密码输入不一致，请重新输入',
  confirmPwd: '请确认密码',
  inputUserName: '请输入用户名',
  inputEmail: '请输入邮箱地址',
  verifySuccess: '验证成功',
  modifyLink: '请登录邮箱点击链接修改您的密码',
  resetSuccess: '重置密码成功',
  loginNow: '马上登录',
  modifySuccess: '修改密码成功',
  newPwd: '请输入新密码',
  newPwdAgain: '请再次输入新密码',
  backToLogin: '返回登录',
  uselessLink: '链接已失效，无法完成邮件验证。请尝试重新发送邮件。',
});

export default messages;
